import { createAction } from '@reduxjs/toolkit';

export const showInteraction = createAction('interaction/showInteraction');
export const videoReady = createAction('videoPlayer/videoReady');
export const setScoreboard = createAction<any>('scoreboard/setScoreboard');
export const showScoreboard = createAction('scoreboard/showScoreboard');
